import { TProductGalleryDuoVariants, TProductGalleryQuartetVariants, TProductGallerySingleVariants, TProductGalleryTrioVariants } from '@features/cms/typescript';
const getInspirationImageSize = (variant: TProductGallerySingleVariants | TProductGalleryDuoVariants | TProductGalleryTrioVariants | TProductGalleryQuartetVariants, isRightText = false) => {
  switch (variant) {
    case 'singleHorizontal':
      return {
        width: ['918px', '918px', '918px', '918px', '100vw'],
        height: ['563px', '563px', '563px', '563px', '46.875vw']
      };
    case 'singleVertical':
      return {
        width: ['563px', '563px', '563px', '563px', '63.4375vw'],
        height: ['918px', '918px', '918px', '918px', '84.375vw']
      };
    case 'duoBigSquare':
      return {
        width: ['100vw', '100vw', '93.75vw', '47.2916667vw'],
        height: ['100vw', '100vw', '93.75vw', '47.34375vw']
      };
    case 'duoBigVertical':
      return {
        width: ['100vw', '100vw', '93.75vw', '39.21875vw'],
        height: ['132.941179vw', '132.941179vw', '124.609375vw', '52.1875vw']
      };
    case 'duoBigHorizontal':
      return {
        width: ['100vw', '100vw', '93.75vw', '47.2916667vw'],
        height: ['74.6666667vw', '74.6666667vw', '70.0520833vw', '37.0833333vw']
      };
    case 'duoSmallSquare':
      return {
        width: ['82.9333333vw', '82.9333333vw', '63.28125vw', '31.1197917vw'],
        height: ['82.9333333vw', '82.9333333vw', '63.28125vw', '31.1979167vw']
      };
    case 'duoSmallVertical':
      return {
        width: ['82.9333333vw', '82.9333333vw', '63.0208333vw', '31.1197917vw'],
        height: ['110.255387vw', '110.255387vw', '83.59375vw', '41.5625vw']
      };
    case 'duoSmallHorizontal':
      return {
        width: ['82.9333333vw', '82.9333333vw', '62.7604167vw', '31.1197917vw'],
        height: ['61.8666667vw', '61.8666667vw', '46.875vw', '24.4020828vw']
      };
    case 'trioSquare':
      return {
        width: ['100vw', '100vw', '49.739583333vw', '31.0677083vw'],
        height: ['100vw', '100vw', '49.739583333vw', '31.1979167vw']
      };
    case 'trioVertical':
      return {
        width: ['100vw', '100vw', '49.739583333vw', '31.0677083vw'],
        height: ['133.066667vw', '133.066667vw', '74.7395833vw', '41.5104167vw']
      };
    case 'trioHorizontal':
      return {
        width: ['100vw', '100vw', '49.739583333vw', '31.0677083vw'],
        height: ['75.2vw', '75.2vw', '36.71875vw', '23.28125vw']
      };
    case 'quartetSquare':
      return {
        width: ['100vw', '100vw', '49.739583333vw', '23.0208333vw'],
        height: ['100vw', '100vw', '49.739583333vw', '23.0208333vw']
      };
    case 'quartetVertical':
      return {
        width: ['100vw', '100vw', '49.739583333vw', '23.0208333vw'],
        height: ['133.066667vw', '133.066667vw', '74.7395833vw', '30.6770833vw']
      };
    case 'quartetHorizontal':
      return {
        width: ['100vw', '100vw', '49.739583333vw', '23.0208333vw'],
        height: ['75.2vw', '75.2vw', '36.71875vw', '17.2916667vw']
      };
    default:
      return {
        width: ['918px', '918px', '918px', '918px', isRightText ? '63.4375vw' : '71.5625vw'],
        height: ['563px', '563px', '563px', '563px', isRightText ? '47.6041667vw' : '53.6979167vw']
      };
  }
};
export default getInspirationImageSize;